import { Box, Button, LinearProgress, Typography } from '@mui/material'
import { alpha, styled } from '@mui/material/styles'
import { Root } from '../styles'

const FOOTER_CONTENT_WIDTH = 320

export const ScreenRoot = styled(Root)({
    position: 'relative'
})

export const PageRoot = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: theme.spacing(2),
    gap: theme.spacing(3)
}))

export const HeroSection = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(1)
}))

/**
 * Halo behind finish-flag illustration.
 * Figma node 297:3 — 320×320 circle, HDS info/lighter (#CDDEFF) radial fade to 0 at 72%.
 */
export const IllustrationBackdrop = styled(Box)(({ theme }) => {
    const infoLighter = theme.palette.info.lighter ?? '#CDDEFF'

    return {
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 320,
        height: 320,
        flexShrink: 0,
        borderRadius: '50%',
        background: `radial-gradient(50% 50% at 50% 50%, ${alpha(infoLighter, 0.9)} 0%, ${alpha(infoLighter, 0)} 72%, ${alpha(infoLighter, 0)} 100%)`
    }
})

export const Title = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
    textAlign: 'center'
}))

export const Subtitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    textAlign: 'center'
}))

export const FooterSection = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    paddingTop: theme.spacing(2.5),
    gap: theme.spacing(1.5)
}))

export const ContinueButton = styled(Button)(() => ({
    width: FOOTER_CONTENT_WIDTH,
    maxWidth: '100%'
}))

export const CountdownMessage = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
    textAlign: 'center',
    width: FOOTER_CONTENT_WIDTH,
    maxWidth: '100%',
    fontWeight: 600
}))

export const StayOnPageMessage = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.secondary,
    textAlign: 'center',
    width: FOOTER_CONTENT_WIDTH,
    maxWidth: '100%'
}))

export const CountdownProgress = styled(LinearProgress)(({ theme }) => ({
    width: FOOTER_CONTENT_WIDTH,
    maxWidth: '100%',
    height: 6,
    borderRadius: 3,
    backgroundColor: alpha(theme.palette.grey[400], 0.35),
    '& .MuiLinearProgress-bar': {
        borderRadius: 3,
        backgroundColor: theme.palette.primary.main
    }
}))
